<template>
  <d-card class="mt-3">
    <d-card-header
      class="px-3 py-2"
      role="tab">
      <d-row>
        <d-col
          lg="4"
          class="mb-4 mb-lg-0">
          <div class="d-flex align-items-center">
            Łącznie dostawy:
            <span class="ml-2">{{ orders.length }}</span>
            <d-button
              v-d-toggle.accordion1
              :class="{
                'inline-flex': true,
                'allDeliveries-button': sectionCollapsedName === 'supplies',
                'allDeliveries-button--transform': sectionCollapsedName !== 'supplies'
              }"
              :theme="sectionCollapsedName === 'supplies' ? 'primary' : 'success'"
              @click.prevent="sectionCollapsed('supplies')">
              <i class="material-icons">
                keyboard_arrow_down
              </i>
            </d-button>
          </div>
        </d-col>
        <d-col
          lg="4"
          class="mb-1 mb-lg-0">
          <div class="d-flex align-items-center">
            Pokaż ile towaru:
            <span class="ml-2">{{ products.length }}</span>
            <d-button
              v-d-toggle.accordion2
              :class="{
                'inline-flex': true,
                'allDeliveries-button': sectionCollapsedName === 'products',
                'allDeliveries-button--transform': sectionCollapsedName !== 'products'
              }"
              :theme="sectionCollapsedName === 'products' ? 'primary' : 'success'"
              @click.prevent="sectionCollapsed('products')">
              <i class="material-icons">
                keyboard_arrow_down
              </i>
            </d-button>
          </div>
        </d-col>
      </d-row>
    </d-card-header>

    <orders-collapse-products
      :products="products"/>
    <orders-collapse-supplies
      :supplies="supplies"/>

    <d-row
      no-gutters
      class="page-header border-top pl-4 pt-4">
      <d-col
        col
        sm="6"
        class="text-center text-sm-left pb-1">
        <h3 class="page-title">Łącznie dostawy</h3>
      </d-col>
    </d-row>
    <div
      v-if="supplies[0]"
      class="sum-group">
      <p
        v-if="supplies[0].price"
        class="mt-3" >
        Łącznie do zapłaty:
        <span>{{supplies[0].price.toFixed(2)}} zł</span>
      </p>
      <p>
        Łącznie przyjęto:
        <span
          :class="{
            'text-warning': (supplies[0].payment_cash + supplies[0].payment_transferred + supplies[0].payment_card).toFixed(2) !== supplies[0].price.toFixed(2),
            'text-green': (supplies[0].payment_cash + supplies[0].payment_transferred + supplies[0].payment_card).toFixed(2) === supplies[0].price.toFixed(2)
          }">
          {{(supplies[0].payment_cash + supplies[0].payment_transferred + supplies[0].payment_card).toFixed(2)}} zł
        </span>
      </p>
      <hr>
      <small
        v-if="supplies[0].payment_cash"
        class="d-block mb-1">
        Łącznie opłacone gotówką:
        <span>{{supplies[0].payment_cash.toFixed(2)}} zł</span>
      </small>
      <small
        v-if="supplies[0].payment_transferred"
        class="d-block mb-1">
        Łączne deklaracje przelewu:
        <span>{{supplies[0].payment_transferred.toFixed(2)}} zł</span>
      </small>
      <small
        v-if="supplies[0].payment_card"
        class="d-block mb-1">
        Łącznie opłacono kartą:
        <span>{{supplies[0].payment_card.toFixed(2)}} zł</span>
      </small>
    </div>
  </d-card>
</template>

<script>
import Vue from 'vue';
import OrdersCollapseSupplies from '@/views/Orders/OrdersCollapseSupplies';
import OrdersCollapseProducts from '@/views/Orders/OrdersCollapseProducts';

export default {
  name: 'orders-collapse',
  components: {
    OrdersCollapseSupplies,
    OrdersCollapseProducts
  },
  props: {
    supplies: {
      type: [Object, Array],
      required: true
    },
    orders: {
      type: [Object, Array],
      required: true
    },
    products: {
      type: [Object, Array],
      required: true
    },
  },
  data () {
    return {
      sectionCollapsedName: ''
    };
  },
  methods: {
    sectionCollapsed (sectionName) {
      if (this.sectionCollapsedName === sectionName) {
        Vue.set(this, 'sectionCollapsedName', '');
        return;
      }
      Vue.set(this, 'sectionCollapsedName', sectionName);
    },
  },
};
</script>

<style lang="scss">
.sum-group {
  padding: 0 2rem 2rem 2rem;
  p {
    display: flex;
    margin: 0;
    font-weight: 200;
    padding-top: 0.5rem;
    span {
      font-weight: 600;
      margin-left: 0.5rem;
    }
  }
}
.collapse_button {
  width: 35px;
  height: 35px;
  margin-top: -0.2rem;
  margin-left: 1rem;
  padding: 0.5rem ;
  border: 1px solid #c8c8c8;
  border-radius: 40px;
  i {
    margin-left: 0.2rem;
  }
}
</style>
